module.exports = __webpack_public_path__ + "static/nobslogo-7e00df1917e8d4546bf92d26fa874060.jpg";